/**
 * `/welcome?ty=<payload>` — thank-you + dashboard setup after a WordPress
 * membership purchase. See lib/purchaseWelcome.ts for the payload contract.
 */
import { WelcomeScreen } from '@/components/welcome/WelcomeScreen';
import { decodeWelcomePayload } from '@/lib/purchaseWelcome';
import { Redirect, useLocalSearchParams } from 'expo-router';
import React, { useMemo } from 'react';

export default function WelcomeRoute() {
  const { ty } = useLocalSearchParams<{ ty?: string | string[] }>();
  const payload = useMemo(() => decodeWelcomePayload(ty), [ty]);

  // Nothing to show without an order: someone typed the URL or the payload
  // was mangled. The catalog is the sensible place to land.
  if (!payload) return <Redirect href="/courses" />;

  return <WelcomeScreen payload={payload} />;
}
